export default __webpack_public_path__ + "static/media/avertthineeyes.054a7ae7.png";